import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie_consent");
    if (!accepted) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-[90] p-4"
          data-testid="cookie-consent"
        >
          <div className="max-w-lg mx-auto bg-[#042F2E] rounded-2xl p-5 shadow-2xl flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <p className="text-white text-sm font-semibold mb-1">Este app usa cookies</p>
              <p className="text-white/60 text-xs leading-relaxed">
                Utilizamos cookies para manter sua sessão e melhorar sua experiência.
                Veja nossa <a href="/privacidade/" className="text-[#FF5A26] underline">Política de Privacidade</a> e <a href="/termos/" className="text-[#FF5A26] underline">Termos de Uso</a>.
              </p>
            </div>
            <button
              onClick={accept}
              className="bg-[#FF5A26] hover:bg-[#E04818] text-white font-bold text-sm px-6 py-2.5 rounded-full shrink-0 transition-colors"
              data-testid="cookie-accept"
            >
              Aceitar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
